import { Navigate } from 'react-router-dom';

import { Role } from '@app/domain-interfaces';

import { useUserAuth } from './user-auth-provider';

type ProtectedRouteProps = {
  children: React.ReactNode;
  allowedRoles?: Role[];
};
export const ProtectedRoute = ({ children, allowedRoles }: ProtectedRouteProps) => {
  const { user } = useUserAuth();

  //At least one of the allowed roles, if specified, should exist in user role list. If not, redirect to access-forbidden page
  if (!allowedRoles?.length || allowedRoles.some((allowedRole) => user?.roles?.[allowedRole])) {
    return <>{children} </>;
  } else {
    return <Navigate to="/access-forbidden" />;
  }
};
